import LABEL from '../../../business-const/Label/Label'

import { 
    TextFieldNumberSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    processaRegistrosDefaultIniciaisPerguntas,
} from './FormServicePerguntas'



export const Formulario = ({ values, handleChange, linhaFormList, completo, formularioList, setPrimInd }) => {

    return (
        <>
            {formularioList.length > 1  && !values.jsonAcessoCliente.acessoCliente && (
                <TextFieldNumberSelect
                    name={"formulario"}
                    label={LABEL.formulario}
                    value={values.formulario || ''}
                    onChange={(e) => {
                        if (setPrimInd) {

                            processaRegistrosDefaultIniciaisPerguntas(
                                values, linhaFormList, formularioList, e.target.value, completo, setPrimInd
                            )
                        }
                        handleChange(e)
                    }}
                    list={formularioList}
                />
            )}
        </>
    )
}